import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import VKTemplateSlide from "../components/VKTemplateSlide";
import { API_HEADERS } from "./config";

export default function VKTwoMarkPageSlide() {
  const [params] = useSearchParams();
  const api = params.get("api"); // ⭐ API received from URL

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    if (!api) {
      alert("API link missing");
      return;
    }

    fetch(api, { headers: API_HEADERS })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((result) => {
        if (Array.isArray(result)) {
          setRows(result);
        } else if (result.data) {
          setRows(result.data);
        } else {
          setRows([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [api]);

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#0d1117",
        gap: 16,
      }}>
        {/* Chalk-dust spinner */}
        <div style={{
          width: 56, height: 56, borderRadius: "50%",
          border: "4px solid #ffffff22",
          borderTop: "4px solid #e2e8f0",
          animation: "spin 0.8s linear infinite",
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={{
          color: "#94a3b8",
          fontFamily: "'Baloo 2', sans-serif",
          fontSize: 15,
          letterSpacing: 1,
        }}>
          Loading slides…
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0d1117",
        color: "#f87171",
        fontFamily: "'Baloo 2', sans-serif",
        fontSize: 15,
        padding: 32,
        textAlign: "center",
      }}>
        ⚠️ Failed to load: {error}
      </div>
    );
  }

  return <VKTemplateSlide rows={rows} />;
}
